export default "{{ activeStep }} of {{ stepCount }}\n";